import { cn } from "@/lib/utils";

export function StatCard({ icon: Icon, label, value, hint, accent = "red", testId }) {
  const accents = {
    red: "bg-brand-red/10 text-brand-red",
    navy: "bg-brand-navy/10 text-brand-navy",
    blue: "bg-brand-blue/10 text-brand-blue",
    green: "bg-pos-bg text-pos-text",
    amber: "bg-neu-bg text-neu-text",
  };
  return (
    <div
      data-testid={testId}
      className="rounded-xl border border-border bg-white p-5 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
    >
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold uppercase tracking-wider text-brand-mute">{label}</p>
        {Icon && (
          <div className={cn("flex h-8 w-8 items-center justify-center rounded-lg", accents[accent])}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <p className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-brand-ink">{value}</p>
      {hint && <p className="mt-1 text-xs text-brand-mute">{hint}</p>}
    </div>
  );
}
